import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'TypeKeikai',
  components: {
    MultipleFileInput
  },
  data () {
    return {
      input: {
        keikaiLevel: null,
        soundFile: null
      }
    }
  },
  mounted () {
    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values,
      relationalNoticeTypeModel: state => state.noticeForm.relationalNoticeTypeModel
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // result
    resultNoticeType () {
      try {
        return this.relationalNoticeTypeModel
          .filter(item => item.deliveryTypeMstUuid === this.values.inpDeliveryType)[0].noticeTypeInfo
          .filter(item => item.noticeTypeMstUuid === this.values.inpNoticeType)[0].noticeTypeName
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // list
    keikaiLevelList () {
      return Constants.Notice.KeikaiLevel
    },

    // validate
    formIsValid () {
      return Validator.validRadio(this.input.keikaiLevel)
    },

    // post用にjsonbを取得
    jsonb () {
      let jsonb = {
        keikaiLevel: this.input.keikaiLevel
      }
      if (Validator.validFile(this.input.soundFile)) {
        jsonb.soundFile = this.input.soundFile
      }
      return jsonb
    }
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })
    },
    // ファイル登録
    changeFile ({index, file}) {
      this.input.soundFile = file
    }
  }
}
